{"regionLabel":"Sprachvorschlag","message":"Diese Seite ist auch auf Deutsch verfügbar.","cta":"Auf Deutsch ansehen","dismiss":"Schließen"}